import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';

export const MessageListContentsSkeleton = () => {
  return (
    <>
      {[...Array(2)].map((_, idx) => {
        return (
          <Box key={idx} css={{ marginBottom: 'default' }}>
            <Bone type="chatBubble" css={{ width: '50%', marginBottom: 'tighter' }} />
            <Bone type="chatBubble" css={{ width: '58.33%', marginBottom: 'tighter' }} />
            <Box css={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 'tighter' }}>
              {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `width: 350px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
              <Bone type="chatBubble" css={{ width: '350px' }} />
            </Box>
            <Bone type="chatBubble" css={{ width: '75%' }} />
          </Box>
        );
      })}
    </>
  );
};

export const MessageListSkeleton = () => {
  return (
    <SkeletonContainer>
      <MessageListContentsSkeleton />
    </SkeletonContainer>
  );
};
